<template>
  <div class="manage-roles-panel">
    <div class="background" @click="close" />
    <section class="wrapper">
      <p class="header">
        Roles Info
        <span class="workflow-id" @click="showWorkflowInfo">{{
          shortWorkflowID
        }}</span>
        <span class="delete is-large is-pulled-right" @click="close" />
      </p>
      <p style="margin: 8px 0" @click="addRole">
        <span class="button is-link is-fullwidth">
          <i class="fa fa-plus fa-sm" />&nbsp;Add Role
        </span>
      </p>
      <div v-if="roles" class="roles no-scrollbar">
        <p class="buttons" style="margin-bottom: 0">
          <span
            v-for="n in roleNames"
            :key="n"
            class="button"
            :class="{ 'is-dark': selectedRoleName === n }"
            @click="selectRoleName(n)"
            >{{ n }}</span
          >
        </p>
        <div
          v-for="r in filteredRoles"
          :key="r.id"
          class="role-wrapper"
          :class="{ 'bg-pink': !r.user }"
          @click="moreInfo(r)"
        >
          <p v-if="r.user" class="is-flex name-phone">
            <span class="user-name">{{ r.user.name }}</span>
            <span class="has-text-link">{{ r.user.phone_number }}</span>
          </p>
          <p v-else class="is-flex name-phone">
            <span class="user-name">Unclaimed</span>
            <span>{{ r.phone_number }} <i class="far fa-times-circle" /></span>
          </p>
          <p class="is-flex">
            <span class="role-name">{{ r.role_name }}</span>
            <span style="flex-grow: 1" />
            <span v-if="r.user" class="time-ago">{{
              timeAgo(r.user.updated_at)
            }}</span>
            <span v-else class="time-ago">{{ timeAgo(r.updated_at) }}</span>
          </p>
        </div>
      </div>
      <div v-else>
        <p v-if="loading">
          <b-skeleton height="36px" />
          <b-skeleton height="36px" />
          <b-skeleton height="36px" />
        </p>
        <p
          v-else
          class="notification is-dark has-text-weight-medium"
          @click="addRole"
        >
          No Roles Yet
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ManageRolesPanel",
  components: {},
  props: {
    w: Object,
  },
  data() {
    return {
      selectedRoleName: null,
      roles: null,
      //   workflow: null,
      loading: true,
    };
  },
  computed: {
    filteredRoles() {
      if (!this.selectedRoleName) return this.roles;
      return this.roles.filter((r) => r.role_name === this.selectedRoleName);
    },
    roleNames() {
      if (!this.roles) return [];
      return [...new Set(this.roles.map((r) => r.role_name))];
    },
    shortWorkflowID() {
      //   if (!this.workflow) return "";
      return this.w.id.substr(this.w.id.length - 5);
    },
  },
  created() {},
  mounted() {
    this.getRolesInfo();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    addRole() {
      this.$emit("addRole");
    },
    selectRoleName(n) {
      if (this.selectedRoleName === n) this.selectedRoleName = null;
      else this.selectedRoleName = n;
    },
    showWorkflowInfo() {
      this.$swal({
        title: "Workflow ID",
        text: this.w.id,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    getRolesInfo() {
      //   var workflowID = this.workflow.id;
      // var loader = this.loadingDots();
      this.$store
        .dispatch("getRolesByWorkflow", this.w.id)
        .then((res) => {
          console.log("getRolesByWorkflow", res.data);
          this.roles = res.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.loading = false));
    },
    roleStyle(r) {
      var color = "red";
      if (r.state === "working") color = "lightgreen";
      if (r.user_id === "") color = "grey";
      return `color: ${color}`;
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    roleIcon(r) {
      if (r.role_name === "Driver") return "fas fa-shuttle-van";
      if (r.role_name === "Dispatcher") return "fas fa-phone-volume";
      if (r.role_name === "Free") return "fa fa-gift";
      return "fas fa-user"; // question
    },
    preDeleteUnclaimedRole(r) {
      this.deleteWorkerRole(r);
      this.successToast("Deleted unclaimed role!");
    },
    moreInfo(r) {
      if (!r.user) {
        this.preDeleteUnclaimedRole(r);
        return;
      }
      this.goto("user_info/" + r.user.id);
      //   var shortID = this.lastFive(r.id);
      //   var t = new Date(r.updated_at);
      //   var timeDiff = Math.round((new Date() - t) / (1000 * 60));
      //   var prettyTime = `${timeDiff} mins ago`;
      //   if (timeDiff > 60) {
      //     timeDiff = Math.round(timeDiff / 60);
      //     prettyTime = `${timeDiff} hours ago`;
      //   }
      //   var prettyLoc = "4 mins ago";
      //   this.$swal({
      //     title: r.user ? r.user.name : "Unclaimed",
      //     html: `<div style='text-align:left'>
      //     Role name <strong>${r.role_name}</strong><br>
      //     Role ID <strong>${shortID}</strong><br>
      //     Role updated <strong>${prettyTime}</strong><br>
      //     Source <strong>${r.user.source}</strong>
      //     </div>`,
      //     showConfirmButton: true,
      //     showCancelButton: true,
      //     showCloseButton: true,
      //     cancelButtonText: "Delete",
      //     cancelButtonColor: this.bulmaColor("danger"),
      //     confirmButtonText: "Edit",
      //   }).then((result) => {
      //     console.log(result);
      //     if (result.dismiss === "cancel") {
      //       this.deleteWorkerRole(r);
      //     }
      //   });
    },
    deleteWorkerRole(r) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteRole", r.id) // should soft delete
        .then((res) => {
          this.console("deleteWorkerRole", res);
          this.getRolesInfo();
        })
        .catch((err) => console.error(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.manage-roles-panel {
  position: absolute;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  z-index: 2;
}
.background {
  position: absolute;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  /* backdrop-filter: blur(1px); */
  height: 100vh;
  width: 100vw;
  /* z-index: 2; */
}
.wrapper {
  position: absolute;
  bottom: 0;
  padding: 12px;
  background-color: white;
  width: 100%;
  text-align: left;
  border-radius: 20px 20px 0px 0px;
  max-height: 80vh;
  height: auto;
  overflow: hidden;
}
.header {
  font-size: 1.3em;
  margin-left: 4px;
  margin-bottom: 4px;
}
.workflow-id {
  background-color: #ddd;
  border-radius: 3px;
  font-size: 0.6em;
  padding: 0px 5px;
}
.role-wrapper {
  /* border: 1px solid #ddd; */
  padding: 3px;
  margin-top: -1px;
  background-color: #eee;
  /* border-bottom: 8px solid white; */
  margin-bottom: 8px;
  border-radius: 3px;
}
.roles {
  overflow: scroll;
  max-height: calc(80vh - 100px);
  /* padding-bottom: 50px; */
  padding-bottom: 8px;
}
.role-name {
  background-color: #eee;
  border-radius: 3px;
  padding: 0 3px;
}
.user-name {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 500;
  /* font-size: 1.1em; */
}
.time-ago {
  flex-shrink: 1;
  text-align: right;
  background-color: #555;
  padding: 0 3px;
  /* font-size: 0.8em; */
  color: #ddd;
  border-radius: 3px;
}
.bg-pink {
  background-color: pink;
}
.name-phone {
  padding: 0 3px;
  margin-bottom: 4px;
  font-size: 1.1em;
}
</style>